import {RoomSticker} from "@/core/api/room.sticker.api";

export default {
  async changeRoomUserSticker({ dispatch, commit, getters, rootGetters }, data) {
    await RoomSticker.changeRoomUserSticker(data);
  },
  async changeAllRoomUserSticker({ dispatch, commit, getters, rootGetters }, data) {
    await RoomSticker.changeAllRoomUserSticker(data);
  },
};
